module.exports = __webpack_public_path__ + "static/media/football-carousel-1280x800.e8c9ecce.jpg";